/**
 * Small ring/donut indicator for Dashboard summary cards.
 * SVG, 48px by default. Silver stroke, amber over 90%, red over 100%.
 * `value` is 0..1 (fraction) or null to render empty.
 */
export default function MiniRing({ value, size = 56, label, testid }) {
  const pct = value == null || isNaN(value) ? 0 : Math.max(0, Math.min(1.2, value));
  const stroke = pct > 1 ? "#ef4444" : pct > 0.9 ? "#fbbf24" : "#B0B8C1";
  const radius = (size / 2) - 6;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - Math.min(1, pct) * circumference;
  return (
    <div className="relative inline-flex items-center justify-center" data-testid={testid} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={size/2} cy={size/2} r={radius} stroke="#262626" strokeWidth="5" fill="none"/>
        <circle cx={size/2} cy={size/2} r={radius} stroke={stroke} strokeWidth="5" fill="none"
                strokeDasharray={circumference} strokeDashoffset={offset}
                strokeLinecap="round" transform={`rotate(-90 ${size/2} ${size/2})`}/>
      </svg>
      <div className="absolute inset-0 flex items-center justify-center text-[10px] text-silver font-bold">
        {label}
      </div>
    </div>
  );
}
